import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCountdownSeconds } from "src/hooks/use-countdown";

interface Props {
  open: boolean;
  onClose: () => void;
  onLogOut: () => void;
  onStayLoggedIn: () => void;
}

export default function AuthExpirationDialog({
  open,
  onClose,
  onLogOut,
  onStayLoggedIn,
}: Props) {
  const { t } = useTranslation();
  const countDownSeconds = 30;
  const { countdown, counting, startCountdown } =
    useCountdownSeconds(countDownSeconds);
  open && startCountdown();
  return (
    <Dialog maxWidth="md" open={open} scroll="body">
      <DialogTitle>
        {t("auth_will_be_expired")}
        {counting && `(${countdown}s)`}
      </DialogTitle>
      <DialogContent>
        {t("auth_will_be_expired_helper_text")}
        <br />
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button onClick={onLogOut} variant="outlined" color="inherit">
              {t("playermenu_logout")}
            </Button>
          </Grid>

          <Grid item textAlign={"right"} xs={6}>
            <Button
              onClick={onStayLoggedIn}
              variant="contained"
              color="secondary"
              size="medium"
            >
              {t("stay_loggedin")}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
